<style src="./BulkOutdatedRegister.scss" lang="scss"></style>
<template>
 <section class="wrapper wrapper-content animated fadeIn">
    <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

    <div class="row">
      <div class="col-md-4">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form class="form-horizontal" @submit.prevent="registerForm">
              <h2>Cadastro</h2>
              <p>Cadastro manual de entrada de crédito e estacionamento</p>
              <br />

              <!-- DATE -->
              <div class="row">
                <div class="col-lg-12 col-xl-6">
                  <div class="form-group">
                    <label class="col-md-12">Data</label>
                    <div class="col-md-12">
                      <input
                        type="date"
                        class="form-control"
                        v-model="registerControl.form.date">
                    </div>
                  </div>
                  <h6 class="text-danger m-b-lg" v-show="registerControl.control.disableSubimitWHenDate">Só será permitido data inferior a 20/07/2019</h6>
                </div>
              </div>

              <!-- WORK SHIFT -->
              <div class="row">
                <div class="col-md-12"><h3>Turnos</h3></div>
                  
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <label class="col-md-12">Hora Inicial</label>
                      <div class="col-md-12">
                        <input
                          ref="inputTime"
                          type="text"
                          class="form-control"
                          v-mask="'##:##:##'"
                          placeholder="HH:MM:SS"
                          v-model="registerControl.form.startTime">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <label class="col-md-12">Troca de Turno</label>
                      <div class="col-md-12">
                        <input
                          ref="inputTime"
                          type="text"
                          class="form-control"
                          v-mask="'##:##:##'"
                          placeholder="HH:MM:SS"
                          v-model="registerControl.form.shiftTime">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <label class="col-md-12">Hora Final</label>
                      <div class="col-md-12">
                        <input
                          ref="inputTime"
                          type="text"
                          class="form-control"
                          v-mask="'##:##:##'"
                          placeholder="HH:MM:SS"
                          v-model="registerControl.form.endTime">
                      </div>
                    </div>
                  </div>
              </div>

              <!-- TARIFFs -->
              <div class="row">
                <div class="col-md-12"><h3>Quantidades</h3></div>

                <div class="col-md-4 col-sm-4">
                  <div class="form-group">
                    <label class="col-md-12">2,00</label>
                    <div class="col-md-12">
                      <input
                        ref="inputAmountPaid"
                        type="text"
                        class="form-control"
                        v-model.lazy="registerControl.form.count200">
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-4">
                  <div class="form-group">
                    <label class="col-md-12">2,50</label>
                    <div class="col-md-12">
                      <input
                        ref="inputAmountPaid"
                        type="text"
                        class="form-control"
                        v-model.lazy="registerControl.form.count250">
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-4">
                  <div class="form-group">
                    <label class="col-md-12">5,00</label>
                    <div class="col-md-12">
                      <input
                        ref="inputTotalMinutes"
                        type="text"
                        class="form-control"
                        v-model="registerControl.form.count500">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2 pull-right">
                  <button
                    class="btn btn-lg btn-primary pull-right btn-submit"
                    :disabled="registerControl.control.disabledSubmit"
                    type="submit">
                    <i class="fa fa-gear"></i>
                    Gerar Preview
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="panel blank-panel">
          <div class="panel-heading">
            <div class="panel-options">
              <ul class="nav nav-tabs">
                <li :class="{ 'active': tabControl.tabVisible === 'team' }"><a @click.prevent="changeTab('team')">Equipes</a></li>
                <li :class="{ 'active': tabControl.tabVisible === 'preview' }"><a @click.prevent="changeTab('preview')">Preview</a></li>
              </ul>
            </div>
          </div>

          <div class="panel-body">
            <div class="tab-content">
              <div class="tab-pane" :class="{ 'active': tabControl.tabVisible === 'team' }">
                <div class="col-md-6 animated fadeInRight">
                  <div class="mail-box-header">
                    <h2>Funcionários</h2>
                  </div>

                  <div class="mail-box ibox-content">
                    <table class="table table-hover table-mail">
                      <thead>
                        <tr>
                          <th>Fora</th>
                          <th>1º</th>
                          <th>2º</th>
                          <th>Nome</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          :class="{ 'employee-row-selected': teamControl.selectedEmployee === item.id }"
                          v-for="(item, idx) in teamControl.employeeList"
                          :key="idx"
                          @click.stop="editEmployeeParking(item.id, idx)">

                          <td><input @click.stop="selectWorkShift(item.id, idx, 0)" type="radio" value="0" v-model="item.shiftSelected" :name="`shiftSelected${idx}`"></td>
                          <td><input @click.stop="selectWorkShift(item.id, idx, 1)" type="radio" value="1" v-model="item.shiftSelected" :name="`shiftSelected${idx}`"></td>
                          <td><input @click.stop="selectWorkShift(item.id, idx, 2)" type="radio" value="2" v-model="item.shiftSelected" :name="`shiftSelected${idx}`"></td>
                          <td>{{ item.fullName }}</td>
                          <td><i class="fa fa-arrow-right"></i></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-md-6 animated fadeInRight">
                  <div class="mail-box-header">
                    <h2>Estacionamentos</h2>
                  </div>
                  
                  <div
                    class="mail-box ibox-content"
                    :class="{ 'list-disbaled': parkingControl.isListDisabled }">
                    <table class="table table-hover table-mail">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Nome</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, idx) in parkingControl.parkingList"
                          :key="idx"
                          disabled="true"
                          @click="selectParking(idx)">

                          <td>
                            <input
                              type="checkbox"
                              v-model="item.selected"
                              :disabled="parkingControl.isListDisabled">
                            </td>
                          <td>{{ item.parkName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="tab-pane" :class="{ 'active': tabControl.tabVisible === 'preview' }">
                <div class="col-md-12 animated fadeInRight">
                  <div class="row">
                    <div class="col-md-2 pull-right">
                      <button
                        class="btn btn-lg btn-primary pull-right btn-submit"
                        type="button"
                        @click="commitToServer">
                        <i class="fa fa-save"></i>
                        Salvar
                      </button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-3">
                      <div class="ibox float-e-margins">
                        <div class="ibox-title text-navy">
                          <h5>TICKET 2,00</h5>
                        </div>
                        <div class="ibox-content text-right">
                          <h1>{{ totalToCurrencyBR(registerControl.previewTotal.ticket200) }}</h1>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="ibox float-e-margins">
                        <div class="ibox-title text-warning">
                          <h5>TICKET 2,50</h5>
                        </div>
                        <div class="ibox-content text-right">
                          <h1>{{ totalToCurrencyBR(registerControl.previewTotal.ticket250) }}</h1>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="ibox float-e-margins">
                        <div class="ibox-title text-danger">
                          <h5>TICKET 5,00</h5>
                        </div>
                        <div class="ibox-content text-right">
                          <h1>{{ totalToCurrencyBR(registerControl.previewTotal.ticket500) }}</h1>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="ibox float-e-margins">
                        <div class="ibox-title text-default">
                          <h5>TOTAL</h5>
                        </div>
                        <div class="ibox-content text-right">
                          <h1>{{ totalToCurrencyBR(registerControl.previewTotal.ticket200 + registerControl.previewTotal.ticket250 + registerControl.previewTotal.ticket500) }}</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mail-box ibox-content">
                    <table class="table table-hover table-mail">
                      <thead>
                        <tr>
                          <th>Placa</th>
                          <th>Data</th>
                          <th>Hora</th>
                          <th>Funcionário</th>
                          <th>Valor Pago</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          v-for="(item, idx) in paginatedPreview"
                          :key="idx">

                          <td>{{ item.licencePlate }}</td>
                          <td>{{ fillDate(item.forceTime) }}</td>
                          <td>{{ fillTime(item.forceTime) }}</td>
                          <td>{{ employeeName(item.userId) }}</td>
                          <td>{{ totalToCurrencyBR(item.creditPaid.amountPaid) }}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="mail-tools tooltip-demo m-t-md">
                      <div class="btn-group pull-right">
                        <button
                          class="btn btn-white btn-sm"
                          @click="firstPage()">
                          <i class="fa fa-fast-backward"></i>
                        </button>
                        <button
                          class="btn btn-white btn-sm"
                          @click="previousPage()">
                          <i class="fa fa-arrow-left"></i>
                        </button>
                        <span class="btn">{{ (registerControl.control.paginated.pageSkip / registerControl.control.paginated.pageLimit) + 1 }} de {{ Math.ceil(registerControl.control.paginated.countPages / registerControl.control.paginated.pageLimit) }}</span>            
                        <button
                          class="btn btn-white btn-sm"
                          @click="nextPage()">
                          <i class="fa fa-arrow-right"></i>
                        </button>
                        <button
                          class="btn btn-white btn-sm"
                          @click="lastPage()">
                          <i class="fa fa-fast-forward"></i>
                        </button>
                      </div>
                      
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>

    <!-- <remove-modal
      :show="formControl.isModalVisible"
      @close-modal="modalIsVisible(false)"
      @confirm="removeRegister">
      ok
    </remove-modal> -->
  </section>
</template>

<script>
  import {mask} from 'vue-the-mask'
  import Spinner from '../../components/Spinner';
  // import RemoveModal from '../../components/remove-modal/RemoveModal'
  import GenerateBulkOutdated from './helpers/GenerateBulkOutdated'
  import MergeCounts from './helpers/MergeCounts'
  import InjectEmployee from './helpers/InjectEmployee'
  import DefineEmployeeWorkShift from './helpers/DefineEmployeeWorkShift'
import { toast } from '@/plugins/toast';

  let licencePlateList = []

  export default {
    name: 'OutdatedRegister',
    components: { Spinner },
    directives: {
      mask,
    },
    data () {
      return {
        showSpinner: false,
        tabControl: {
          tabVisible: 'team'
        },
        teamControl: {
          employeeList: [],
          selectedEmployee: null,
          selectedEmployeeIdx: null,
          selectedList: {}
        },
        parkingControl: {
          parkingList: [],
          isListDisabled: true
        },
        vehicleControl: {
          listLicencePlates: []
        },
        registerControl: {
          form: {
            date: '',
            startTime: '07:00:00',
            shiftTime: '12:45:23',
            endTime: '19:00:00',
            count200: 1082,
            count250: 243,
            count500: 85
          },
          preview: [],
          previewTotal: {
            ticket200: 0,
            ticket250: 0,
            ticket500: 0
          },
          control: {
            paginated: {
              countPages: 0,
              pageLimit: 30,
              pageSkip: 0
            },
            disableSubimitWHenDate: false,
            disabledSubmit: false
          }
        }
      }
    },
    mounted () {
      this.listEmployees()
      this.listParkings()
      this.listLicencePlates()
    },
    computed: {
      paginatedPreview() {
        if (this.registerControl.preview.length === 0) { return [] }
        const pageSkip = this.registerControl.control.paginated.pageSkip
        const pageLimit = pageSkip + this.registerControl.control.paginated.pageLimit
        const paginated = this.registerControl.preview.slice(pageSkip, pageLimit)
        return paginated
      }
    },
    methods: {
      fillDate(value) {
        return new Date(value).toLocaleDateString("pt-BR")
      },
      fillTime(value) {
        return new Date(value).toLocaleTimeString("pt-BR")
      },
      totalToCurrencyBR(value) {
        if (!value) {
         return "-"
        }
        return (value / 100).toLocaleString("pt-BR", {
          minimumFractionDigits: 2
        })
      },
      employeeName (value) {
        const employeeName = this.teamControl.employeeList.find(item => item.id === value)
        return employeeName.fullName
      },
      changeTab(tab) {
        this.tabControl.tabVisible = tab
      },
      async listLicencePlates() {
        const { licencePlates } = await this.$store.dispatch('VEHICLE/ListLicencePlates')
        licencePlateList = licencePlates
      },
      async listEmployees() {
        const employeeListFull = await this.$store.dispatch('EMPLOYEE/GetEmployeeList')
        const employeeList = employeeListFull.map(item => ({
          id: item.userToken,
          userToken: item.userToken,
          fullName: item.fullName,
          shiftSelected: 0
        }));

        this.teamControl.employeeList = employeeList;
      },
      async listParkings() {
        const parkingListFull = await this.$store.dispatch('PARKING/GetParkList')
        const parkingList = parkingListFull.map(item => ({
          id: item._id,
          parkName: item.parkName,
          selected: false
        }));
        this.parkingControl.parkingList = parkingList;
      },
      selectParking(parkingIdx) {
        const selectedEmployeeInfo = this.teamControl.employeeList[this.teamControl.selectedEmployeeIdx]
        const selectedEmployeeId = selectedEmployeeInfo && selectedEmployeeInfo.id ? selectedEmployeeInfo.id : false
        if (!selectedEmployeeId) { return }
        if (this.parkingControl.isListDisabled) { return }

        const parkingSelected = this.parkingControl.parkingList[parkingIdx].selected
        this.parkingControl.parkingList[parkingIdx].selected = !parkingSelected

        const indexOfParking = this.teamControl.selectedList[selectedEmployeeId].parkings.indexOf(this.parkingControl.parkingList[parkingIdx].id)

        if (indexOfParking > -1) {
          this.teamControl.selectedList[selectedEmployeeId].parkings.splice(indexOfParking, 1)
        } else {
          this.teamControl.selectedList[selectedEmployeeId].parkings.push(this.parkingControl.parkingList[parkingIdx].id)
        }
      },
      editEmployeeParking(employeeId, employeeIdx, pWorkShift = false) {
        const workShift = pWorkShift || this.teamControl.employeeList[employeeIdx].shiftSelected

        this.teamControl.selectedEmployeeIdx = employeeIdx
        this.teamControl.selectedEmployee = employeeId
        this.parkingControl.isListDisabled = false

        if (!this.teamControl.selectedList[employeeId]) {
          this.teamControl.selectedList[employeeId] = {
            workShift,
            parkings: []
          }
        } else {
          this.teamControl.selectedList[employeeId].workShift = workShift
        }
        this.checkParkings(employeeId)

      },
      disableParkingList() {
        this.parkingControl.isListDisabled = true
        this.uncheckAllParks()
      },
      checkParkings(employeeId) {
        const selectedParking = this.parkingControl.parkingList.map(item => {
          const parkings = this.teamControl.selectedList[employeeId].parkings
          const isParkingSelected = parkings.find((park) => park === item.id)
          const parkingListSelected = {
            ...item
          }
          if (isParkingSelected) {
            parkingListSelected.selected = true
          } else {
            parkingListSelected.selected = false
          }

          return parkingListSelected
        })
        this.parkingControl.parkingList = selectedParking
      },
      uncheckAllParks() {
        const allUnselectedParks = this.parkingControl.parkingList.map((item) => ({ ...item, shiftSelected: false }))
        this.parkingControl.parkingList = allUnselectedParks
      },
      selectWorkShift(employeeId, employeeIdx, workShift) {
        this.editEmployeeParking(employeeId, employeeIdx, workShift)
      },
      registerForm() {
        // Check fields
        // Bloquear data maior que 19/07/2019
        const generatedDate = new Date(`${this.registerControl.form.date} ${this.registerControl.form.startTime}`)
        if (generatedDate >= new Date(2019, 7, 20, 0, 0, 0)) {
          toast.error('Não é possível gerar com data acima de 20/08/2019')
          return
        }

        if (Object.keys(this.teamControl.selectedList).length < 1) {
          toast.error('Você deve definir os times do 1º e 2º turno primeiro')
          return
        }

        const shiftDate = new Date(`${this.registerControl.form.date} ${this.registerControl.form.shiftTime}`)
        const counts = GenerateBulkOutdated(this.registerControl.form, licencePlateList)
        const { mergedCounts, sum200, sum250, sum500 } = MergeCounts(counts)
        const definedEmployeeWorkShift = DefineEmployeeWorkShift(this.teamControl.selectedList)
        InjectEmployee(mergedCounts, definedEmployeeWorkShift, shiftDate)

        this.registerControl.preview = mergedCounts
        this.registerControl.previewTotal.ticket200 = sum200
        this.registerControl.previewTotal.ticket250 = sum250
        this.registerControl.previewTotal.ticket500 = sum500

        this.registerControl.control.paginated.countPages = mergedCounts.length
        this.tabControl.tabVisible = 'preview'
      },
      firstPage() {
        this.registerControl.control.paginated.pageSkip = 0
      },
      previousPage() {
        if (this.registerControl.control.paginated.pageSkip === 0) {
          return;
        }
        this.registerControl.control.paginated.pageSkip = this.registerControl.control.paginated.pageSkip - this.registerControl.control.paginated.pageLimit;
      },
      nextPage() {
        if (this.registerControl.control.paginated.pageSkip + this.registerControl.control.paginated.pageLimit >= this.registerControl.control.paginated.countPages) {
          return;
        }
        const pageSkip = this.registerControl.control.paginated.pageSkip + this.registerControl.control.paginated.pageLimit;
        this.registerControl.control.paginated.pageSkip = pageSkip
      },
      lastPage() {
        const lastPage = Math.floor(this.registerControl.control.paginated.countPages / this.registerControl.control.paginated.pageLimit) * this.registerControl.control.paginated.pageLimit
        this.registerControl.control.paginated.pageSkip = lastPage
      },
      async commitToServer() {
        try {
          this.showSpinner = true
          await this.$store.dispatch('VEHICLE/BulkPayParkingTakeout', { payload: this.registerControl.preview })
          toast.success('Registros inseridos com sucesso')
        } catch (error) {
          toast.success('Ocorreu um problema')
        } finally {
          this.showSpinner = false
        }
      }
    }
  }
</script>